import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=46df403e&scoped=true&"
import script from "./MenuItems.vue?vue&type=script&lang=js&"
export * from "./MenuItems.vue?vue&type=script&lang=js&"
import style0 from "./MenuItems.vue?vue&type=style&index=0&id=46df403e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df403e",
  null
  
)

export default component.exports